import { ChangeDetectionStrategy, Component, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'custom-account-invoices-page',
  templateUrl: './account-invoices-page.component.html',
  styleUrls: ['./account-invoices-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountInvoicesPageComponent {
  @ViewChild('invoiceNumberInput') invoiceNumberInput!: ElementRef;

  invoices = [
    {
      id: 'I1661722',
      transactionDate: '09-06-2024',
      dueDate: '10-06-2024',
      daysOverdue: 180,
      amount: 647.2,
      status: 'unpaid',
    },
    {
      id: 'I1661723',
      transactionDate: '08-06-2024',
      dueDate: '09-06-2024',
      daysOverdue: 179,
      amount: 1200.5,
      status: 'paid',
    },
    {
      id: 'I1661724',
      transactionDate: '07-06-2024',
      dueDate: '08-06-2024',
      daysOverdue: 178,
      amount: 3450.75,
      status: 'unpaid',
    },
    {
      id: 'I1661725',
      transactionDate: '06-06-2024',
      dueDate: '07-06-2024',
      daysOverdue: 177,
      amount: 2150.0,
      status: 'paid',
    },
    {
      id: 'I1661726',
      transactionDate: '05-06-2024',
      dueDate: '06-06-2024',
      daysOverdue: 176,
      amount: 980.3,
      status: 'unpaid',
    },
  ];

  filteredInvoices = [...this.invoices];
  transactionDateFrom: string | null = null;
  transactionDateTo: string | null = null;
  paymentStatus: string = 'all';

  onInvoiceNumberInput(value: String) {
    const invoiceNumber = value;
    this.filteredInvoices = this.invoices.filter(invoice =>
      invoice.id.toLowerCase().includes(invoiceNumber.toLowerCase())
    );
  }

  searchInvoices(event: Event) {
    const invoiceNumber = (event.target as HTMLInputElement).value;
    this.filteredInvoices = this.invoices.filter(invoice =>
      invoice.id.toLowerCase().includes(invoiceNumber.toLowerCase())
    );
    this.applyFilters();
  }

  onTransactionDateFromChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.transactionDateFrom = value;
    this.applyFilters();
  }

  onTransactionDateToChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.transactionDateTo = value;
    this.applyFilters();
  }

  onPaymentStatusChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.paymentStatus = value;
    this.applyFilters();
  }

  applyFilters() {
    this.filteredInvoices = this.invoices.filter(invoice => {
      const matchesDateFrom = this.transactionDateFrom
        ? new Date(invoice.transactionDate) >= new Date(this.transactionDateFrom)
        : true;
      const matchesDateTo = this.transactionDateTo
        ? new Date(invoice.transactionDate) <= new Date(this.transactionDateTo)
        : true;
      const matchesStatus = this.paymentStatus === 'all' || invoice.status === this.paymentStatus;

      return matchesDateFrom && matchesDateTo && matchesStatus;
    });
  }

  clearSearch() {
    this.filteredInvoices = [...this.invoices];
    this.transactionDateFrom = null;
    this.transactionDateTo = null;
    this.paymentStatus = 'all';
    if (this.invoiceNumberInput) {
      this.invoiceNumberInput.nativeElement.value = '';
    }
  }
}
